import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './Home.css'
import HomeBannerimage from "./images/home-banner-image3.png"
import BGdots from './images/bg_dots.svg'
import Reacticon from './images/icons/react.svg'
import liveclassimg from "./images/about_shape.svg"
import vdo from '../../assets/images/videoplayback (1).mp4'

import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeBanner = () => {



  useEffect(() => {
    AOS.init();
  }, []);



  return (
    <div className="home_banner">
    <video autoPlay loop muted playsInline className="home_banner_video">
      <source src={vdo} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6 home_banner_text" data-aos="fade-up" data-aos-duration="2000">
          <h5>Reach your career</h5>
          <h2>Learn from the best <span>online</span> training course</h2>
          <p>Elevate your career with the best online training courses tailored to help you succeed.</p>
          <div>
            <Link to="/user-about"><button className="learn_more_btn">Learn More <span><i className="ri-arrow-right-line"></i></span></button></Link>
            <Link to="/user-courses"><button className="view_courses_btn">View Courses <span><i className="ri-arrow-right-line"></i></span></button></Link>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  

  )
}

export default HomeBanner

